export function syncSplideSlidesInert(slider) {
	const updateSlides = () => {
		slider.querySelectorAll('.splide__slide').forEach((slide) => {
			slide.toggleAttribute(
				'inert',
				slide.getAttribute('aria-hidden') === 'true',
			);
		});
	};

	const observer = new MutationObserver(updateSlides);
	observer.observe(slider, {
		attributes: true,
		attributeFilter: ['aria-hidden'],
		childList: true,
		subtree: true,
	});

	updateSlides();
}
